




































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Injector } from '@/config/dependency-injection'
import { OfferLite } from '@/business/offers/models/offer-lite'
import { DialogService } from '@/shared/dialog/dialog-service'
import draggable from 'vuedraggable'
import { Form } from '@/shared/forms/form'
import { HomeForm } from '@/business/administration/models/home-form'
import { Prop } from 'vue-property-decorator'
import { backgroundImage } from '@/shared/utils/images'

@Component({
  components: {
    draggable,
  },
  inject: ['form'],
})
export default class HomeOffers extends Vue {
  @Prop({
    required: true,
    type: String,
  })
  public readonly control!: keyof HomeForm

  @Prop({
    required: true,
    type: String,
  })
  public readonly dialogName!: string

  public readonly backgroundImage = backgroundImage

  public readonly form!: Form<any, HomeForm>

  public get formControlValue(): any[] {
    return this.form.value[this.control]
  }

  public set formControlValue(value) {
    this.form.value[this.control] = value
  }

  private dialogService = Injector.get(DialogService)

  public openAddDialog(offer?: OfferLite) {
    this.dialogService.open(this.dialogName, {
      offer,
    })
  }

  public remove(index: any) {
    this.formControlValue = this.formControlValue
      .slice(0, index)
      .concat(this.formControlValue.slice(index + 1))
  }
}
